export default __webpack_public_path__ + "static/media/error.cae5ec02.svg";